<script lang="ts">
	import BlockRenderer from '@comp/BlockRenderer.svelte';
	import type { DoubleContentBlock } from './DoubleContentBlockQuery';
	import { ID_TO_BLOCK } from '@blocks/content/AllContentBlocks';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';

	const { data }: { data: DoubleContentBlock } = $props();
	createViewController();
</script>

<section use:ViewController>
	<div class="container left theme-{data.firstTheme}" use:EnterOnView>
		<div class="content">
			<BlockRenderer
				sections={data.first}
				sectionMap={ID_TO_BLOCK}
				caller="double_content"
				theme={data.firstTheme}
			/>
		</div>
	</div>
	<div class="container right theme-{data.secondTheme}" use:EnterOnView={{ delay: 0.15 }}>
		<div class="content">
			<BlockRenderer
				sections={data.second}
				sectionMap={ID_TO_BLOCK}
				caller="double_content"
				theme={data.secondTheme}
			/>
		</div>
	</div>
</section>

<style lang="scss">
	$margin-bottom: 152px;

	section {
		@include layoutBlockGrid;
		@include blockPadding(true);

		.container {
			align-self: start;
			grid-column: 1 / -1;
			height: 100%;

			background-color: hsl(var(--color-foreground));
			color: hsl(var(--color-background));

			&.theme-light {
				background-color: hsl(var(--color-primary));
				color: hsl(var(--color-foreground));
			}
		}

		.left {
			@include md {
				grid-column: 1 / span 6;
			}
		}
		.right {
			@include md {
				grid-column: 7 / -1;
			}
		}

		.content {
			position: relative;
			display: flex;
			width: 100%;
			height: 100%;
			padding: 40px;

			@include md {
				padding: 50px;
			}
		}
	}
</style>
